<template>
    <div style="height: 96%;">
        <div class="crumbs mcrumb-self">
            <el-breadcrumb separator="-">
                <el-breadcrumb-item>
					<i class="el-icon-files"></i><span>档案整理</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item><span>档案分组</span></el-breadcrumb-item>
			</el-breadcrumb>
        </div>
        <!-- <el-divider></el-divider> -->
        
        <div class="container">
            <div style="display: flex;padding-top: 12px;">
                <div style="width: 60px;margin-right: 15px;line-height: 37px;"><label style="color: #606266;">分组状态</label></div>
                <div class="voucher-img-div" v-for="(imgObj, index) in archiveGroupStatusImgList" :key="index">
                    <img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="groupStatusImgClickFun($event, index)">
                </div>
            </div>
            <div>
                <el-checkbox v-model="group_checked" @change="changeGroupAll">全选</el-checkbox>
            </div>
            <el-divider></el-divider>
            <div class="my-container" style="height: 80%;">
                <el-row style="padding-bottom: 10px;">
                    <div style="display: flex;float: left">
                        <el-button type="primary" @click="fastGroupClickFun()">一键分组</el-button>
                        <el-button type="primary" @click="manualGroupClickFun('1', '')">手工分组</el-button>
                        <el-button plain style="width: 80px;" @click="restoreArchiveGroupDataClickFun()">拆组</el-button>
                        <el-button plain @click="setGroupedArchiveGroupDataClickFun()">置为已分组</el-button>
                        <el-button plain @click="setGroupingArchiveGroupDataClickFun()">置为分组中</el-button>
                        <!-- <el-button plain @click="updateGroupLevelClickFun()">组密级修改</el-button> -->
                    </div>
                    <el-input v-model="archiveGroupSearchName" placeholder="组号、所属实体、凭证号、金额" style="width:350px;float: right;" prefix-icon="el-icon-search" @keyup.native="fuzzyQueryGroupData"/>
                </el-row>
                <div style="display: flex;height: 99%;">
                    <div style="width: 70%;">
                        <el-table ref="archiveGroupTable" :data="archiveGroupTableData" border stripe class="table" height="93%" @row-click="(row) => clickRowByChecked('archiveGroupTable', row)" >
                            <el-table-column type="selection" width="50"></el-table-column>
                            <el-table-column prop="id" v-if="showColumn == true"></el-table-column>
                            <el-table-column prop="groupNo" label="组号" sortable></el-table-column>
                            <el-table-column prop="companyName" width="200" label="所属实体" sortable></el-table-column>
                            <el-table-column prop="voucherNo" label="记账凭证号" sortable></el-table-column>
                            <el-table-column prop="amount" label="主件金额" sortable :formatter="(row, column, cellValue, index) => this.formatAmountSeparator(cellValue)"></el-table-column>
                            <el-table-column prop="count" width="110" label="组文件数" sortable align="center"></el-table-column>
                            <el-table-column prop="secretLevel" width="110" label="组密级" sortable align="center">
                                <template slot-scope="scoped">
                                    <span>{{scoped.row.secretLevel}}级</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="status" width="120" label="档案状态" align="center">
                                <template slot-scope="scoped">
                                    <div v-for="(imgObj, index) in formatGroupStatusImgList" :key="index">
                                        <img v-if="scoped.row.status == imgObj.code" :src="require('../../../assets/img/' + imgObj.name+ '.png')">
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operate" label="操作" width="120" fixed="right" align="center">
                                <template slot-scope="scoped">
                                    <el-button size="small" type="text" @click="manualGroupClickFun('2', scoped.row)">编辑分组</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh('grouppwm')"></el-link>
                            <el-pagination
                                @size-change="(val) => handleSizeChange('grouppwm', val)"
                                @current-change="(val) => handleCurrentChange('grouppwm', val)"
                                :current-page="grouppwm.page"
                                :page-size="grouppwm.limit"
                                :page-sizes="grouppwm.limits"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="grouppwm.count">
                            </el-pagination>
                        </div>
                    </div>
                    <div style="width: 30%;">
                        <el-card style="height: 93%;overflow-y: auto;margin-left: 20px;">
                            <el-form :model="archiveGoupDetailForm">
                                <span class="voucher-tag-title" style="font-size: 16px;line-height: 30px;">查看详情</span>
                                <div style="padding: 5px 0px;">
                                    <span class="voucher-tag-title" style="margin-bottom: 10px;">组内文件</span>
                                    <div id="archivesInv" v-for="(inv, index) in archiveGoupDetailForm.groupDetailData" :key="index">
                                        <el-container>
                                            <el-aside style="width: 50px;height: 50px;padding-top: 6px;">
                                                <div v-for="(imgObj, index) in voucherTypeImgList" :key="index">
                                                    <img v-if="imgObj.code == inv.type" :src="require('../../../assets/img/' + imgObj.name+ '.png')">
                                                </div>
                                            </el-aside>
                                            <el-main style="padding: 0 0 0 0 !important;">
                                                <div class="archivesview-textline">
                                                    <!-- <span style="margin-right:10px;">{{inv.typeName}}</span> -->
                                                    <el-link type="primary" @click="archiveGroupVoucherNoClickFun(index)" style="line-height: 20px;">{{inv.voucherNo}}</el-link>
                                                    <span style="margin-left:10px;color:red">￥{{inv.amount}}</span>
                                                </div>
                                                <div class="archivesview-timeline"><span>{{inv.voucherDate}}</span></div>
                                            </el-main>
                                        </el-container>
                                    </div>
                                </div>
                                <div style="padding: 5px 0px;">
                                    <div class="voucher-tag-title">操作信息</div>
                                    <div style="line-height: 25px;">
                                        <span class="voucher-tag-contmg">最近操作人：{{archiveGoupDetailForm.operator}}</span>
                                    </div>
                                    <div style="line-height: 25px;">
                                        <span class="voucher-tag-contmg">最近更新时间：{{this.timestampFormatter(archiveGoupDetailForm.opTime)}}</span>
                                    </div>
                                </div>
                            </el-form>
                        </el-card>
                    </div>
                </div>
            </div>
        </div>

        <!-- 手工分组 / 编辑分组 -->
        <el-dialog :title="manualGroupTitle" custom-class="dialog-custom" :visible.sync="manualGroupDialogVisible" width="80%" class="dialog" :close-on-click-modal="false">
            <div class="custom-dialog">
                <div style="display: flex;">
                    <el-button type="primary" @click="tempSaveManualGroupDetailClickFun">置为分组中</el-button>
                    <el-button type="primary" @click="saveManualGroupDetailClickFun">置为已分组</el-button>
                    <div style="line-height: 32px;text-align: right;padding-left: 30px;">组号：<span>{{ this.manualGroupForm.manualGroupNo }}</span></div>
                    <el-input v-if="showColumn == true" v-model="this.manualGroupForm.manualGroupId"></el-input>
                </div>
                <el-divider></el-divider>
                <div style="display: flex;">
                    <div style="width: 35%;margin-right: 10px;">
                        <span style="margin: 5px 0px;font-weight: bold;color: #66b1ff;line-height: 32px;">组文件及排序</span>
                        <div class="group-inv-container">
                            <ul style="width: 98%;">
                                <draggable v-model="manualGroupForm.manualGroupDetailData" :options="dragOptions" :move="moved">
                                    <transition-group tag="div">
                                        <div v-for="(inv, index) in manualGroupForm.manualGroupDetailData" :key="index">
                                            <li style="display: flex;width: 90%;" @click="manualGroupDetailNodeClickFun(index)" :id="manualGroupDetailNodeId + index">
                                                <el-container style="padding: 10px 0px 0px 15px;">
                                                    <div class="group-inv-ind">{{ index + 1 }}</div>
                                                    <el-aside style="width: 50px;height: 50px;padding-top: 6px;">
                                                        <div v-if="showColumn == true">{{inv.type}}</div>
                                                        <div v-for="(imgObj, index) in voucherTypeImgList" :key="index">
                                                            <img v-if="imgObj.code == inv.type" :src="require('../../../assets/img/' + imgObj.name+ '.png')">
                                                        </div>
                                                    </el-aside>
                                                    <el-main style="padding: 0 0 0 0 !important;">
                                                        <div class="archivesview-textline">
                                                            <span>{{inv.voucherNo}}</span>
                                                            <span style="margin-left:10px;color:red">￥{{inv.amount}}</span>
                                                        </div>
                                                        <div class="archivesview-timeline"><span>{{inv.opDate}}</span></div>
                                                    </el-main>
                                                </el-container>
                                            </li>
                                        </div>
                                    </transition-group>
                                </draggable>
                            </ul>
                        </div>
                    </div>
                    <div style="width: 5%;text-align: center;">
                        <div style="padding-top: 200px">
                            <el-button plain @click="moveLeft()"><i class="el-icon-d-arrow-left" style="font-size: 14px;font-weight: bold;"></i></el-button>
                        </div>
                        <div style="padding-top: 40px;">
                            <el-button plain @click="moveRight()"><i class="el-icon-d-arrow-right" style="font-size: 14px;font-weight: bold;"></i></el-button>
                        </div>
                    </div>
                    <div style="width: 60%;margin-left: 10px;">
                        <el-row style="padding-bottom: 10px;line-height: 32px;">
                            <el-col :span="4" style="padding-right: 30px;">
                                <span style="margin: 5px 0px;font-weight: bold;color: #66b1ff;">添加组文件</span>
                            </el-col>
                            <el-col :span="20" style="text-align: right;">
								<!-- <label style="color: #606266;font-size: 14px;padding-right: 20px;">所属实体</label> -->
								<el-select v-model="manualGroupCompanyName" placeholder="所属实体" style="width: 350px;" @change="companyNameSelectChange">
									<el-option
										v-for="item in manualGroupCompanyData"
										:key="item.id"
										:label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-col>
                        </el-row>
                        <div style="margin-bottom: -30px;text-align: right;">
                            <el-input v-model="manualGroupSearchName" placeholder="凭证号、含税金额、流程号" prefix-icon="el-icon-search" clearable style="width: 350px;z-index: 9999;" @keyup.native="fuzzyQueryManualGroupData"></el-input>
                        </div>
                        <div>
                            <el-tabs v-model="manualGroupTabs" type="card">
                                <el-tab-pane label="记账凭证" name="1">
                                    <el-table ref="manualGroupAccVoucherTable" :data="manualGroupAccVoucherTableData" border stripe class="table" height="440" @row-click="(row) => clickRowByChecked('manualGroupAccVoucherTable', row)" @select-all = "selectAll" :row-class-name="tableRowClassName">
                                        <el-table-column type="selection" width="50"></el-table-column>
                                        <el-table-column prop="id" v-if="showColumn == true"></el-table-column>
                                        <el-table-column prop="voucherNo" label="凭证号码" sortable></el-table-column>
                                        <el-table-column prop="voucherDate" label="凭证日期" sortable :formatter="(row, column, cellValue, index) => this.timestampFormatter(cellValue)"></el-table-column>
                                        <el-table-column prop="amount" label="凭证金额" sortable :formatter="(row, column, cellValue, index) => this.formatAmountSeparator(cellValue)"></el-table-column>
                                        <el-table-column prop="companyName" label="所属实体" width="200" sortable></el-table-column>
                                        <!-- <el-table-column prop="operate" label="操作" width="90" fixed="right" align="center">
                                            <template>
                                                <el-button size="small" type="text" @click="manualGroupAddFun()">添加</el-button>
                                                <el-button size="small" type="text">预览</el-button>
                                            </template>
                                        </el-table-column> -->
                                    </el-table>
                                    <div class="pagination">
                                        <el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh('accvoucherpwm')"></el-link>
                                        <el-pagination
                                            @size-change="(val) => handleSizeChange('accvoucherpwm', val)"
                                            @current-change="(val) => handleCurrentChange('accvoucherpwm', val)"
                                            :current-page="accvoucherpwm.page"
                                            :page-size="accvoucherpwm.limit"
                                            :page-sizes="accvoucherpwm.limits"
                                            layout="total, sizes, prev, pager, next, jumper"
                                            :total="accvoucherpwm.count">
                                        </el-pagination>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="原始凭证" name="2">
                                    <el-table ref="manualGroupOriVoucherTable" :data="manualGroupOriVoucherTableData" border stripe class="table" height="440" @row-click="(row) => clickRowByChecked('manualGroupOriVoucherTable', row)" :row-class-name="tableRowClassName">
                                        <el-table-column type="selection" width="50"></el-table-column>
                                        <el-table-column prop="id" v-if="showColumn == true"></el-table-column>
                                        <el-table-column prop="type" label="凭证类型" width="80" align="center">
                                            <template slot-scope="scoped">
                                                <div v-for="(imgObj, index) in voucherTypeImgList" :key="index">
                                                    <img v-if="imgObj.code == scoped.row.type" :src="require('../../../assets/img/' + imgObj.name + '.png')">
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="voucherNo" label="凭证号码" sortable></el-table-column>manualGroupOriVoucherTable
                                        <el-table-column prop="voucherDate" label="凭证日期" sortable :formatter="(row, column, cellValue, index) => this.timestampFormatter(cellValue)"></el-table-column>
                                        <el-table-column prop="amount" label="凭证金额" sortable :formatter="(row, column, cellValue, index) => this.formatAmountSeparator(cellValue)"></el-table-column>
                                        <!-- <el-table-column prop="companyName" label="所属实体" width="200" sortable></el-table-column> -->
                                        <!-- <el-table-column prop="operate" label="操作" width="90" fixed="right" align="center">
                                            <template>
                                                <el-button size="small" type="text" @click="manualGroupAddFun()">添加</el-button>
                                                <el-button size="small" type="text">预览</el-button>
                                            </template>
                                        </el-table-column> -->
                                    </el-table>
                                    <div class="pagination">
                                        <el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh('orivoucherpwm')"></el-link>
                                        <el-pagination
                                            @size-change="(val) => handleSizeChange('orivoucherpwm', val)"
                                            @current-change="(val) => handleCurrentChange('orivoucherpwm', val)"
                                            :current-page="orivoucherpwm.page"
                                            :page-size="orivoucherpwm.limit"
                                            :page-sizes="orivoucherpwm.limits"
                                            layout="total, sizes, prev, pager, next, jumper"
                                            :total="orivoucherpwm.count">
                                        </el-pagination>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <!-- 册密级修改 dialog -->
        <el-dialog title="密级修改" :visible.sync="groupLevelDialogVisible" width="25%" top="40vh" :close-on-click-modal="false">
            <div class="custom-dialog" style="height: 130px;">
                <el-form ref="groupLevelForm" :model="groupLevelForm">
                    <div style="line-height: 35px;">当前共选中<span style="color: #409EFF;padding: 0px 5px;">{{groupLevelForm.count}}</span>组，</div>
                    <div style="line-height: 35px;">
                        <span>密级统一修改为</span>
                        <el-select v-model="groupLevelForm.groupLevel" placeholder="请选择" style="width: 150px;padding: 0px 10px;" @change="groupLevelSelectChange">
                            <el-option
                                v-for="item in groupLevelData"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <div class="el-form-item__error" style="top: 63%;left: 130px;" v-if="this.showLevelMsg == true">密级不能为空</div>
                    </div>
                </el-form>
                <div style="text-align: center;padding-top: 25px;">
                    <el-button type="primary" style="width: 80px;" @click="saveGroupLevelClickFun()">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 查看文件明细 -->
        <custom ref="voucher" :voucher="voucher"></custom>
    </div>
</template>

<script>
import https, { fetchPost } from '../../../../https.js';
import voucher from '../common/custom.vue';
import draggable from 'vuedraggable';

export default {
    name: 'basetable',
    data() {
        return{
            grouppwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
            accvoucherpwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
            orivoucherpwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
            voucher: {
                vid: '',
                vftype: '',
            },
            archiveGroupStatusImgList: JSON.parse(JSON.stringify(this.archiveGroupStatusList)),
            formatGroupStatusImgList: JSON.parse(JSON.stringify(this.archiveGroupStatusList)),
            voucherTypeImgList: JSON.parse(JSON.stringify(this.originalvoucherTypeList)).concat(JSON.parse(JSON.stringify(this.accountingVoucherTypeList))),
            archiveGroupSearchName: '',
            showColumn: false,
            archiveGroupTableData: [],
            archiveGoupDetailForm: {
                groupDetailData: [],
                operator: '',
                opTime: ''
            },
            manualGroupDialogVisible: false,    //  手工分组
            manualGroupTitle: '新增手工分组',
            manualGroupTabs: "1",
            manualGroupCompanyName: '', //  所属实体
            manualGroupCompanyData: [],
            manualGroupSearchName: '',
            manualGroupForm: {
                manualGroupId: '',  //  组ID
                manualGroupNo: '',  // 组号
                manualGroupDetailData: [],  //  组内明细文件
            },
            manualGroupAccVoucherTableData: [],
            manualGroupOriVoucherTableData: [],
            manualGroupDetailNodeId: 'detail_node_',
            currUserSecretLevel: '',
            showLevelMsg: false,
            groupLevelDialogVisible: false,
            groupLevelForm: {
                count: 0,
                groupLevel: '',
                ids: ''
            },
            groupLevelData: JSON.parse(JSON.stringify(this.secretLevelList)),
            oriVoucherUploadInfoForm: [],
            dragOptions:{
                animation: 120,
                scroll: true,
                group: 'sortlist',
                ghostClass: 'ghost-style',
            },
            group_checked:true,
        }
    },
    components: {
        voucher,
        draggable
    },
    created: function() {
        this.loadArchiveGroupData();
    },
    methods: {
        refresh(pwmName) {
            this.loadTableDataByPageChange(pwmName);
        },
        handleSizeChange(pwmName, val) {
            this[pwmName].limit = val;
            this.loadTableDataByPageChange(pwmName);
		},
		handleCurrentChange(pwmName, val) {
            this[pwmName].page = val;
            this.loadTableDataByPageChange(pwmName);
        },
        async loadTableDataByPageChange(pwmName) {
             if(pwmName == 'grouppwm') {
                this.loadArchiveGroupData();
            } else if(pwmName == 'accvoucherpwm') {
                this.getManualGroupAccVoucherData();
            } else if(pwmName == 'orivoucherpwm') {
                this.getManualGroupOriVoucherData();
            }
        },  
        clickRowByChecked(refTableName, rowData) {
            if(refTableName == 'manualGroupAccVoucherTable') {  //  手工分组 仅支持单选
                this.$refs[refTableName].clearSelection();
            }
            this.$refs[refTableName].toggleRowSelection(rowData);

             //  显示右侧详情
            this.loadArchiveGroupDetailData(rowData);
        },
        selectAll() {
            this.$refs.manualGroupAccVoucherTable.clearSelection();
        },
        // selectable(row,index){
        // if(row.imageType == '2'){
        //         return false;
        // }
        //     return true;
        // },
        tableRowClassName({row, rowIndex}) {
            row.rowIndex = rowIndex;
        },
        companyNameSelectChange(event, item) {  //  手工分组 - 所属实体下拉 change
            this.getManualGroupAccVoucherData();
            this.getManualGroupOriVoucherData();
        },
        async loadArchiveGroupData() {
            this.getCheckGroupStatusCondition();
            this.getArchiveGroupData().then((data) => {
                if(this.archiveGroupTableData && this.archiveGroupTableData.length > 0) {
                    //  默认选中第一条
                    let firstGroupData = this.archiveGroupTableData[0];
                    this.clickRowByChecked('archiveGroupTable', firstGroupData);
                }
            });
        },
        async loadArchiveGroupDetailData(groupData) {
            this.archiveGoupDetailForm.operator = groupData.operator;
            this.archiveGoupDetailForm.opTime = groupData.createTime;
            this.getArchiveGroupDetailData(groupData.id).then(groupDetailData => {
                this.archiveGoupDetailForm.groupDetailData = groupDetailData;
            });
        },
        async getArchiveGroupData() {
            let pwm = this.grouppwm;
            pwm.likeSearch = this.archiveGroupSearchName;
            await fetchPost('/collation/group/getCollationGroupList', pwm).then(res => {
                this.archiveGroupTableData = res.data.data;
                this.grouppwm.count = res.data.count;
            }, error => {
                this.$message.error('加载分组信息失败：' + error);
            });
        },
        async getArchiveGroupDetailData(id) {   //  获取组明细信息
            let groupDetailData = [];
            await fetchPost('/collation/group/getGroupVoucherListByGroupId', id).then(res => {
                if(res.data.success) {
                    groupDetailData = res.data.obj;
                } else {
                    this.$message.error('加载分组详情信息失败：' + res.data.message);    
                }
            }, error => {
                this.$message.error('加载分组详情信息失败：' + error);
            });
            return groupDetailData;
        },
        async getManualGroupAccVoucherData() {  //  手工分组 - 记账凭证
            let pwm = this.accvoucherpwm;
            pwm.search = { "companyId": this.manualGroupCompanyName};
            pwm.likeSearch = this.manualGroupSearchName;
            await fetchPost('/collation/group/getCanGroupVoucherHeaderList', pwm).then(res => {
                this.manualGroupAccVoucherTableData = res.data.data;
                this.accvoucherpwm.count = res.data.count;
            }, error => {
                this.$message.error('加载记账凭证数据失败：' + error);
            });
        },
        async getManualGroupOriVoucherData() {  //  手工分组 - 原始凭证
            let pwm = this.orivoucherpwm;
            pwm.search = { "companyId": this.manualGroupCompanyName};
            pwm.likeSearch = this.manualGroupSearchName;
            await fetchPost('/collation/group/getCanGroupOriVoucherList', pwm).then(res => {
                this.manualGroupOriVoucherTableData = res.data.data;
                this.orivoucherpwm.count = res.data.count;
            }, error => {
                this.$message.error('加载原始凭证数据失败：' + error);
            });
        },
        fuzzyQueryGroupData() { //  模糊查询
            this.loadArchiveGroupData();
        },
        fuzzyQueryManualGroupData() {
            if(this.manualGroupTabs == '1') {
                this.getManualGroupAccVoucherData();
            } else if(this.manualGroupTabs == '2') {
                this.getManualGroupOriVoucherData();
            }
        },
        groupStatusImgClickFun(event, index) {	//	分组状态点击选中/取消选中效果
			let imgObj = event.currentTarget;
			let imgName = imgObj.name;
			if((imgName.lastIndexOf('-h') + 2) != imgName.length) {
                this.archiveGroupStatusImgList[index].name = imgName + '-h';
			} else {
                this.archiveGroupStatusImgList[index].name = imgName.substr(0, imgName.lastIndexOf('-h'));
            }
            let checkGroupStatusList = [];
			let groupStatusImgList = this.archiveGroupStatusImgList;
			groupStatusImgList.forEach(statusObj => {
				if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
					checkGroupStatusList.push(statusObj.code);
				}
			});
			if(!checkGroupStatusList || checkGroupStatusList.length == 0) {
                this.$message.error('至少需要展示一个分组状态！');
                this.archiveGroupStatusImgList[index].name = imgName;
				return false;
            }
            this.loadArchiveGroupData();
        },
        async getCheckGroupStatusCondition() {    //  获取勾选分组状态的条件
            //	勾选的文件状态
			let checkGroupStatusList = [];
			let groupStatusImgList = this.archiveGroupStatusImgList;
			groupStatusImgList.forEach(statusObj => {
				if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
					checkGroupStatusList.push(statusObj.code);
				}
			});
			if(!checkGroupStatusList || checkGroupStatusList.length == 0) {
				this.$message.error('至少需要展示一个分组状态！');
				return false;
            }
            this.grouppwm.search = { 'groupStatusList': checkGroupStatusList.join(',') };
        },
        updateGroupLevelClickFun() {    //  组密级修改
            this.showLevelMsg = false;
            let checkRows = this.$refs.archiveGroupTable.selection;
            if(!checkRows || checkRows.length == 0) {
                this.$message.warning('请选择需要密级修改的组信息！');
                return;
            }
            this.getUserSecretLevel().then(userLevel => {
                if(!userLevel) {
					this.$message.error('获取当前用户信息失败：用户未设置密级权限！');
					return;
				}
				this.currUserSecretLevel = userLevel;

                let idList = [];
                for (let i = 0; i < checkRows.length; i++) {
                    const row = checkRows[i];
                    //	用户无法修改密级权限比自身高的册文件密级权限。
                    if(parseInt(userLevel) > parseInt(row.secretLevel)) {
                        this.$message.error('不允许修改高于当前用户密级权限的组信息！');
                        return;
                    }
                    idList.push(row.id);
                }
                this.groupLevelForm.count = checkRows.length;
                this.groupLevelForm.ids = idList.join(',');
                this.groupLevelDialogVisible = true;
            });
        },
        groupLevelSelectChange(val) {
            if(val) {
                this.showLevelMsg = false;
            }
        },
        saveGroupLevelClickFun() {
            if(!this.groupLevelForm.groupLevel) {
                this.showLevelMsg = true;
            } else {
                this.showLevelMsg = false;
            }
            if(!this.showLevelMsg) {
                //	 判断当前用户密级权限是否比修改后的组密级权限低
                if(parseInt(this.groupLevelForm.groupLevel) < parseInt(this.currUserSecretLevel)) {
                    this.$confirm('当前修改的密级权限比用户密级权限高，是否确认修改？', '提示', { type: 'warning' }).then(res => {
                        this.saveGroupLevelData();
                    });
                } else {
                    this.saveGroupLevelData();
                }
            }
        },
        saveGroupLevelData() {
            let levelParam = this.groupLevelForm;
            fetchPost('/collation/group/updateArchiveGroupSecretLevel', levelParam).then(res => {
                if(res.data.success) {
                    this.groupLevelDialogVisible = false;
                    this.$message.success('组密级修改成功！');
                    this.loadArchiveGroupData();
                } else {
                    this.$message.error('组密级修改失败：' + res.data.message);
                }
            }, error => {
                this.$message.error('组密级修改失败：' + error);
            });
        },
        fastGroupClickFun() {   //  一键快速分组
            this.$confirm('是否一键快速分组？', '提示', { type: 'warning' }).then(res => {
                //  一键快速分组
                fetchPost('/trigger/autoGroup', '').then(res => {
                    console.log(res)
                    if(res.data.success) {
                        this.$message.success("操作成功！刷新页面查看结果");
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            });
        },
        manualGroupClickFun(type, rowData) {  //  手工分组
            this.manualGroupTabs = "1"; //  默认记账凭证tab页签
            //  清空form 信息
            this.manualGroupForm.manualGroupId = "";
            this.manualGroupForm.manualGroupNo = '';  // 组号
            this.manualGroupForm.manualGroupDetailData = [];  //  组内明细文件
            //  加载用户勾选实体信息
            this.getUserCheckCompanyList().then(companyData => {
                if(companyData && companyData.length > 0) {
                   this.manualGroupCompanyName = companyData[0].id;
                }
                this.manualGroupCompanyData = companyData;

                this.getManualGroupAccVoucherData();
                this.getManualGroupOriVoucherData();
            });
            if(type == '1') {
                this.manualGroupTitle = "新增手工分组";
                this.manualGroupForm.manualGroupNo = '';
            } else if(type == '2') {
                this.manualGroupTitle = "编辑分组";
                this.manualGroupForm.manualGroupId = rowData.id;
                this.manualGroupForm.manualGroupNo = rowData.groupNo;
                this.manualGroupSearchName = "";
                 //  获取当前组内明细数据
                this.getArchiveGroupDetailData(rowData.id).then(groupDetailData => {
                    //  处理金额、日期字段
                    if(groupDetailData && groupDetailData.length > 0) {
                        groupDetailData.forEach(detail => {
                            detail.amount = this.formatAmountSeparator(detail.amount);
                            detail.opDate = this.timestampFormatter(detail.voucherDate);
                        });
                    }
                    this.manualGroupForm.manualGroupDetailData = groupDetailData;
                });
            }
            this.manualGroupDialogVisible = true;
        },
        manualGroupDetailNodeClickFun(index) {
            let node = document.getElementById(this.manualGroupDetailNodeId + index);
            let detailData = this.manualGroupForm.manualGroupDetailData[index];
            detailData.index = index;
            if(!node.style.backgroundColor) {
                node.style = "background-color: #ecf5ff;";
                detailData.checked = true;
            } else {
                node.style.backgroundColor = "";
                detailData.checked = false;
            }
        },
        moveLeft() {    //  手工分组：左移
            let checkRows = [];
            if(this.manualGroupTabs == '1') {
                checkRows = this.$refs.manualGroupAccVoucherTable.selection;

                if(!checkRows || checkRows.length == 0) {
                    this.$message.error('请选择需要左移的记账凭证数据！');
                    return;
                }
                checkRows.forEach(i =>{
                    if(i.imageType == 2){
                        this.$message.error('附件不能被分组');
                        return;
                    }
                });
                //  根据rowIndex 升序
                checkRows.sort(function(a, b) {
                    return a.rowIndex- b.rowIndex;
                });
                this.addManualGroupDetailAccVoucherData(checkRows);   //  将选中记账凭证数据添加至组内
            } else if(this.manualGroupTabs == '2') {
                checkRows = this.$refs.manualGroupOriVoucherTable.selection;
                
                if(!checkRows || checkRows.length == 0) {
                    this.$message.error('请选择需要左移的原始凭证数据！');
                    return;
                }
                checkRows.forEach(i =>{
                    console.log(i)
                    if(i.imageType == 2){
                        this.$message.error('附件不能被分组');
                        return;
                    }
                });
                //  根据rowIndex 升序
                checkRows.sort(function(a, b) {
                    return a.rowIndex- b.rowIndex;
                });
                this.addManualGroupDetailOriVoucherData(checkRows);   //  将选中记账凭证数据添加至组内
            }
        },
        async addManualGroupDetailAccVoucherData(checkRows) {   //  将选中记账凭证数据添加至组内
            //  单个分组内仅能存在一条记账凭证数据
            let rowData = checkRows[0];
            rowData.type = '0'; //  凭证类型：记账凭证
            rowData.amount = this.formatAmountSeparator(rowData.amount);
            rowData.opDate = this.timestampFormatter(rowData.voucherDate);
            let groupDetailData = this.manualGroupForm.manualGroupDetailData;
            if(!groupDetailData || groupDetailData.length == 0) {
                this.manualGroupForm.manualGroupDetailData.push(rowData);

                 //  删除记账凭证table选中数据
                this.manualGroupAccVoucherTableData.splice(rowData.rowIndex, 1);
            } else {
                let flag = false;
                for (let i = checkRows.length - 1; i >= 0; i--) {
                    const detail = groupDetailData[i];
                    if(detail.type == rowData.type) {
                        flag = true;
                        this.$confirm('一个分组中仅能有一份记账凭证，是否确认替换为当前选中的记账凭证？', '提示', { type: 'warning' }).then(res => {
                            this.manualGroupAccVoucherTableData.push(detail);

                            this.$set(this.manualGroupForm.manualGroupDetailData, i, rowData);

                            //  删除记账凭证table选中数据
                            this.manualGroupAccVoucherTableData.splice(rowData.rowIndex, 1);
                        });
                    }
                }
                if(!flag) {
                    this.manualGroupForm.manualGroupDetailData.unshift(rowData);
                    //  删除记账凭证table选中数据
                    this.manualGroupAccVoucherTableData.splice(rowData.rowIndex, 1);
                }
            }
        },
        async addManualGroupDetailOriVoucherData(checkRows) {   //  将选中原始凭证数据添加至组内
            for (let i = checkRows.length - 1; i >= 0; i--) { 
                let row = checkRows[i];
                row.amount = this.formatAmountSeparator(row.amount);
                row.opDate = this.timestampFormatter(row.voucherDate);
                row.checked = false;
                this.manualGroupForm.manualGroupDetailData.push(row);
                //  删除原始凭证table选中数据
                this.manualGroupOriVoucherTableData.splice(checkRows[i].rowIndex, 1);
            }
        },
        moveRight() {   //  手工分组：右移
            let detailData = this.manualGroupForm.manualGroupDetailData;
            let checkDetailData = [];
            detailData.forEach(detail => {
                if(detail.checked) {
                    checkDetailData.push(detail);
                }
            });
            if(!checkDetailData || checkDetailData.length == 0) {
                this.$message.error('请选择需要右移的组文件！');
                return;
            }
            for (let i = checkDetailData.length - 1; i >= 0; i--) {
                this.manualGroupDetailNodeClickFun(checkDetailData[i].index);

                if(checkDetailData[i].type == '0') {    //  记账凭证
                    this.manualGroupAccVoucherTableData.push(checkDetailData[i]);
                } else {
                    this.manualGroupOriVoucherTableData.push(checkDetailData[i]);
                }
                //  删除组文件选中数据
                this.manualGroupForm.manualGroupDetailData.splice(checkDetailData[i].index, 1);
            }
        },
        tempSaveManualGroupDetailClickFun() {   //  手工分组 - 置为分组中
            let groupDetailData = this.manualGroupForm.manualGroupDetailData;
            if(!groupDetailData || groupDetailData.length == 0) {
                this.$message.error('分组文件为空！');
                return;
            }
            this.assembleManualGroupDetailData('0').then(detailParam => {
                console.log("grouping json ==>" + JSON.stringify(detailParam));
                this.tempSaveManualGroupDetailData(detailParam);
            });
        },
        async tempSaveManualGroupDetailData(json) {
            fetchPost('/collation/group/saveArchiveGrouping', json).then(res => {
                if(res.data.success) {
                    this.$message.success('置为分组中成功！');
                    this.manualGroupDialogVisible = false;
                    this.loadArchiveGroupData();
                } else {
                    this.$message.error('置为分组中失败：' + res.data.message);
                }
            }, error => {   
                this.$message.error('置为分组中失败：' + error);
            }); 
        },
        saveManualGroupDetailClickFun() {   //  手工分组 - 置为已分组
            let groupDetailData = this.manualGroupForm.manualGroupDetailData;
            if(!this.manualGroupForm.manualGroupDetailData || this.manualGroupForm.manualGroupDetailData.length == 0) {
                this.$message.error('分组文件为空！');
                return;
            }
            let accVoucherList = groupDetailData.filter(detail => {
                return detail.type == '0';
            });
            let oriVoucherList = groupDetailData.filter(detail => {
                return detail.type != '0';
            });
            //  每个分组内仅存在一张记账凭证
            if(!accVoucherList || accVoucherList.length == 0) {
                this.$message.error('分组中必须存在一张记账凭证！');
                return;
            }
            // if(!oriVoucherList || oriVoucherList.length == 0) {
            //     this.$message.error('分组中必须存在一张至多张原始凭证！');
            //     return;
            // }
            this.assembleManualGroupDetailData('1').then(detailParam => {
                this.saveManualGroupDetailData(detailParam);
            });
        },
        saveManualGroupDetailData(json) {
            fetchPost('/collation/group/saveArchiveGrouped', json).then(res => {
                if(res.data.success) {
                    this.$message.success('置为已分组成功！');
                    this.manualGroupDialogVisible = false;
                    this.loadArchiveGroupData();
                } else {
                    this.$message.error('置为已分组失败：' + res.data.message);
                }
            }, error => {   
                this.$message.error('置为已分组失败：' + error);
            });
        },
        async assembleManualGroupDetailData(saveType) { //  手工分组 - 拼接保存的参数 saveType：0-暂存 1-保存
            let groupDetailData = this.manualGroupForm.manualGroupDetailData;
            let voucherId = "";
            let oriVoucherIdList = [];
            if(groupDetailData && groupDetailData.length > 0) {
                groupDetailData.forEach(detail => {
                if(detail.type == '0') {
                    voucherId= detail.id;
                } else {
                    oriVoucherIdList.push(detail.id);
                }
            });   
            }
            let detailParam = {};
            detailParam.id = this.manualGroupForm.manualGroupId;
            detailParam.companyId = this.manualGroupCompanyName;
            detailParam.voucherId = voucherId;
            detailParam.oriVoucherIds = oriVoucherIdList.join(',');
            return detailParam;
        },
        restoreArchiveGroupDataClickFun() { //  拆组
            this.getArchiveGroupTableCheckIds('请选择需要拆组的档案信息！').then(ids => {
                this.saveRestoreArchiveGroupData(ids);
            })
        },
        saveRestoreArchiveGroupData(ids) {
            fetchPost('/collation/group/restoreArchiveGroup', ids).then(res => {
                if(res.data.success) {
                    this.$message.success('档案信息拆组成功！');
                    this.loadArchiveGroupData();
                } else {
                    this.$message.error('档案信息拆组失败：' + res.data.message);
                }
            }, error => {
                this.$message.error('档案信息拆组失败：' + error);
            });
        },
        setGroupedArchiveGroupDataClickFun() {  //  置为已分组
            let checkRows = this.$refs.archiveGroupTable.selection;
            if(!checkRows || checkRows.length == 0) {
                this.$message.error("请选择需要置为已分组的档案信息！");
                return;
            }
            let idList = [];
            for (let i = 0; i < checkRows.length; i++) {
                const row = checkRows[i];
                if(row.status != '0') {
                    this.$message.error('仅支持分组中的档案置为已分组，请检查！');
                }
                idList.push(row.id);
            }
            this.setGroupedArchiveGroupData(idList.join(','));
        },
        setGroupedArchiveGroupData(ids) {
            fetchPost('/collation/group/setArchiveGrouped', ids).then(res => {
                if(res.data.success) {
                    this.$message.success('档案信息置为已分组成功！');
                    this.loadArchiveGroupData();
                } else {
                    this.$message.error('档案信息置为已分组失败：' + res.data.message);
                }
            }, error => {
                this.$message.error('档案信息置为已分组失败：' + error);
            });
        },
        setGroupingArchiveGroupDataClickFun() {  //  置为分组中
             let checkRows = this.$refs.archiveGroupTable.selection;
            if(!checkRows || checkRows.length == 0) {
                this.$message.error("请选择需要置为分组中的档案信息！");
                return;
            }
            let idList = [];
            for (let i = 0; i < checkRows.length; i++) {
                const row = checkRows[i];
                if(row.status != '1') {
                    this.$message.error('仅支持已分组的档案置为分组中，请检查！');
                    return;
                }
                idList.push(row.id);
            }
            this.setGroupingArchiveGroupData(idList.join(','));
        },
        setGroupingArchiveGroupData(ids) {
            fetchPost('/collation/group/setArchiveGrouping', ids).then(res => {
                if(res.data.success) {
                    this.$message.success('档案信息置为分组中成功！');
                    this.loadArchiveGroupData();
                } else {
                    this.$message.error('档案信息置为分组中失败：' + res.data.message);
                }
            }, error => {
                this.$message.error('档案信息置为分组中失败：' + error);
            });
        },
        async getArchiveGroupTableCheckIds(errorMsg) {
            let checkRows = this.$refs.archiveGroupTable.selection;
            if(!checkRows || checkRows.length == 0) {
                this.$message.error(errorMsg);
                return;
            }
            let idList = [];
			checkRows.forEach(row => {
				idList.push(row.id);
            });
            return idList.join(',');
        },
        archiveGroupVoucherNoClickFun(index) {   //  点击组内文件 凭证号 - 查看文件
            let detailData = this.archiveGoupDetailForm.groupDetailData[index];
            let vftype = "2";
            if(detailData.type == '0') {
                vftype = '1';   //  记账凭证
            } 
            this.voucher.vftype = vftype;
            this.voucher.vid = detailData.id;
            this.$refs.voucher.viewVoucherDetailsClickFun();
        },
        moved(event, originalEvent) {
            // draggedContext: 被拖拽的元素
            // index: 被拖拽的元素的序号
            // element: 被拖拽的元素对应的对象
            // futureIndex: 预期位置、目标位置
            // relatedContext: 将停靠的对象
            // index: 目标停靠对象的序号
            // element: 目标的元素对应的对象
            // list:  目标数组
            // component: 将停靠的vue组件对象
            // console.log(event.draggedContext);  //  被拖拽的元素
            // console.log(event.draggedContext.index);   //  被拖拽的元素的index
            // console.log(event.draggedContext.element); //  被拖拽的元素对应的对象
            if(event.draggedContext.element.type == '0') {    //  记账凭证不允许拖拽
                return false;
            }
            if(event.draggedContext.futureIndex == '0') {
                return false;
            }
            return true;
        },
		changeGroupAll(event){
			if(!event){
				this.group_checked = false;
				this.archiveGroupStatusImgList.forEach(statusObj => {
					if(statusObj.code != '1'){
						if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
							statusObj.name = statusObj.name + '-h';
						}
					}
				});
			}else{
				this.group_checked = true;
				this.archiveGroupStatusImgList.forEach(statusObj => {
					if(statusObj.name.substr(statusObj.name.length - 2) == '-h') {
						statusObj.name = statusObj.name.substr(0,statusObj.name.length - 2);
					}
				});
			}
           this.loadArchiveGroupData();
		},


    },
    watch: {
        'manualGroupTabs': function(val) {
            if(val == '1') {
                // this.getManualGroupAccVoucherData();
            } else if(val == '2') {
                // this.getManualGroupOriVoucherData();
            }
        }
    }
}
</script>
<style scoped>
.table {
	width: 100%;
	font-size: 14px;
}
.dialog-custom .el-dialog__body div{
	padding: -10px 0 0 10px !important;
}
.group-inv-container {
    display: flex;
    height: 500px;
    overflow-y: auto;
}
.group-inv-container ul{
    list-style-type: none;
}
.group-inv-container ul li {
    height: 70px;
    border-bottom: 1px solid #DCDFE6;
    cursor: pointer;
}
.group-inv-container .group-inv-ind {
    width: 20px;
    height: 50px;
    line-height: 50px;
    padding-right: 10px;
    font-size: 14px;
    font-weight: bold;
}
.group-inv-container .group-inv-icon {
    height: 70px;
    line-height: 80px;
    padding-left: 20px;
}
.group-inv-container .group-inv-icon i {
    color: #606266;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
}
.voucher-tag-title {
	font-size:14px;
	font-weight:bold;
	line-height: 25px;
    color: #66b1ff;
}
.voucher-tag-contmg {
	font-size: 12px;
	color:#909399;
}
</style>